import React, { useState } from "react";
import { Button, Col, Form, Row } from "antd";
import CommentBox from "../../../components/commentBox";
import TaskCheckedList from "../../../components/taskCheckedList";
import PageHeader from "../../../components/pageHeader";
import image1 from "../../../../../../../assets/images/owner-statement.jpeg";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../firebase";

function ProPhotos({ itemId, listId, alreadyCheckedItems }) {
  const isItemChecked = alreadyCheckedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <PageHeader pageHeading="Pro Photos" />
          </Col>
          <Col span={24}>
            <h3 className="blue-info-text red-info-heading">
              Always check first to see if we already have pro pics before
              ordering pics. If unsure how to check please log into nested tours
              and also check here
            </h3>
          </Col>
          <Col span={24}>
            <p className="blue-info-text">
              You can either use Nested Tours for the photos or Esteban also
              offers this service for the same rate.
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text">
              You now need to enter a bill - bill entry
            </p>
          </Col>
          <Col span={24}>
            <img className="owner-statement-img" src={image1} alt="" />
          </Col>
          <Col span={24}>
            <p className="blue-info-text">
              If the owner wants professional pics follow these steps.
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text">
              -go to this link{" "}
              <span className="onclick-text">nested tours</span>
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text">
              -login -{" "}
              <span className="onclick-text">admin@integrityoklahoma.com</span>
            </p>
          </Col>
          <Col span={24}>
            <p className="blue-info-text">-password - Integrityok2021</p>
          </Col>
          <Col span={24}>
            <h3 className="blue-info-text">Follow these steps closely!</h3>
          </Col>
          <Col span={24}>
            <ul className="blue-info-text">
              <li>
                <span>
                  -Currently he wants a Photo Tour & 2 Virtual Staging pictures
                  for every property
                </span>
              </li>
              <li>
                <span>- After logging in, it'll pull up an order form</span>
              </li>
              <li>
                <span>
                  - Add address and it will fill in all other information - Next
                </span>
              </li>
              <li>
                <span>- Photo Products - “Add” Photo Tour </span>
              </li>
              <li>
                <span>
                  - Photo Products - “Add” Virtual Staging - For Virtual Staging
                  change quantity to “2” - Next
                </span>
              </li>
              <li>
                <span>
                  - Any Available Photographer - Choose Day/Time - Next{" "}
                </span>
              </li>
              <li>
                <span>- Add coupon code: INTEGRITYOK15 - Apply</span>
              </li>
              <li>
                <span>
                  - In “Notes” section add: “Lockbox code: 16079 - For the
                  virtual staging, the owner would like one of the living room
                  and one of the master bedroom or larger bedroom. Thanks”
                  (16079 can be used for every codebox, it's our vendor code for
                  owners/vendors only){" "}
                </span>
              </li>
              <li>
                <span>
                  - Choose our card already in account - Confirm Order
                </span>
              </li>
              <li>
                <span>
                  -They normally email the pictures to me within 24 hours of
                  taking them, if you don't receive an email you can check in
                  our account on their site and it'll show all of our orders and
                  you can download them there
                </span>
              </li>
            </ul>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button
                  type="primary"
                  onClick={handleComplete}
                  disabled={isDisabled}
                >
                  Completed
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default ProPhotos;
